// Brand assets for GFS / PROcess
// Logo is served from /public/gfs-logo.png so the app does not depend on an
// external CDN that can fail DNS resolution.
export const GFS_LOGO_URL = "/gfs-logo.png";
